// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
if (!global._babelPolyfill) {
  require("babel-polyfill");
}

import Vue from "vue";
import store from "./vuex";
import App from "./App";
import router from "./router";
import "@/assets/common/rem.js";
// import TgaPlatform from '@tgagame/platform-sdk'

import VueTouch from "vue-touch";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "../node_modules/swiper/dist/css/swiper.css";
import axios from "./utils/axios";
import VueCropper from "vue-cropper";

import VueI18n from "vue-i18n";
// 引入语言包
import LangEN from "@/assets/common/lang/en.js";
import LangTR from "@/assets/common/lang/tr.js";
import LangJA from "@/assets/common/lang/ja.js";

// window.tgaPlatformSDK = TgaPlatform
Vue.use(VueCropper);
Vue.prototype.$axios = axios;

Vue.use(VueTouch, {
  name: "v-touch"
});
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

Vue.use(VueI18n);

// const query = tgaPlatformSDK.util.url.getUrlQuery()

// const VConsole = require('./utils/vconsole');
import initTgaPlatformSDK from "@/config/tgaPlatformSDK";

const i18n = new VueI18n({
  locale: "en",
  messages: {
    en: LangEN,
    tr: LangTR,
    ja: LangJA
  },
  silentTranslationWarn: true
});
/* eslint-disable no-new */

VueTouch.config.swipe = {
  threshold: 1, //设置左右滑动的距离
  direction: "horizontal"
};
/* eslint-disable no-new */

// 注册一个全局自定义指令 `v-focus`
Vue.directive("focus", {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus();
  }
});

function setStatusBarColor(status) {
  if (window.TgaBridge) {
    const res = TgaBridge.statusBarColor(status);
  }
}

let vue = "";
let init = () => {
  initTgaPlatformSDK().then(() => {
    const query = tgaPlatformSDK.util.url.getUrlQuery();

    if (query.theme) {
      localStorage.setItem("biptheme", query.theme);
    } else {
      query.theme = localStorage.getItem("theme");
      localStorage.setItem("biptheme", query.theme);
    }
    // 判断引入颜色
    let color = "";
    switch (query.theme) {
      case "dark-blue":
        import("@/css/customized/khalasPay.css");
        color = "12172a";
        break;
      case "dark":
        import("@/css/customized/dark.css");
        color = "0f0d14";
        break;
      case "candlelight":
        import("@/css/customized/candlelight.css");
        color = "ffdb0d";
        break;
      case "lavender":
        import("@/css/customized/lavender.css");
        color = "9876d0";
        break;
      case "orange":
        import("@/css/customized/orange.css");
        color = "fa9c2a";
        break;
      case "night-blue":
        import("@/css/customized/night-blue.css");
        color = "213042";
        break;
      default:
        import("@/css/customized/default.css");
        color = "03a9f5";
        break;
    }

    setStatusBarColor(color);

    vue = new Vue({
      data: function () {
        return {
          adOff: false,
          loading: false
        };
      },
      el: "#app",
      router,
      store,
      i18n,
      components: {
        App
      },
      template: "<App/>",
      created() { }
    });
  });
};

let userAgent = navigator.userAgent;

if (userAgent.indexOf("KuleWebview") > -1) {
  try {
    gtag("event", "sdk", {
      version: userAgent.match(/.+KuleWebview\/(.+)$/)[1]
    });
  } catch (error) {
  }
  window.Bridge.onReady = () => {
    init();
  };
  window.Bridge.onReady();
} else {
  gtag("event", "sdk", {
    version: 0
  });
  init();
}

export default vue;



// WEBPACK FOOTER //
// ./src/main.js